export default function Header() {
    return (
        <div className="App-footer">
            <span>ALL RIGHTS RESERVED, COPYRIGHT © 2023</span>
        </div>
    )
}